// extracted by mini-css-extract-plugin
module.exports = {"container":"OffersCategoriesMenu_container__qMqNt","mobileContainer":"OffersCategoriesMenu_mobileContainer__fVDFU"};